var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgMail(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: "#00965E",
    d: "M4 4h24v24H4z"
  }), React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M22.5 12v8h-13v-8h13zm-.765 1.21L16 17l-5.736-3.79v6.063h11.471V13.21zm-.752-.483h-9.966L16 16.02l4.983-3.293z"
  })));
}

export default SvgMail;